import { Fragment, useState } from 'react'
import { useTranslation } from 'next-i18next'

import useLocale from '~/hooks/useLocale'
import { DATE_TIME_FORMAT } from '~/shared/constants/time.const'
import { ProductCategory, Session } from '~/types/tutoring-api'

import AddComment from './AddComment'
import AddCommentButton from './AddCommentButton'

export default function SessionsLogItem({
  currentComment,
  id,
  isTutor,
  name,
  startTime,
  type,
}: {
  currentComment: Session['mentorComment']
  id: number
  isTutor?: boolean
  name: string | undefined
  startTime: string
  type: ProductCategory
}): React.ReactElement {
  const { t } = useTranslation('generics')
  const [displayCommentTextarea, setDisplayCommentTextarea] = useState(false)
  const locale = useLocale()

  return (
    <Fragment>
      <div className="flex justify-between items-center">
        <div className="flex flex-col leading-5">
          <span className="font-light text-gray-light-fade text-xs capitalize">
            {new Date(startTime).toLocaleDateString(locale, DATE_TIME_FORMAT.DAY_MONTH_WEEKDAY)}
          </span>
          <span className="font-semibold text-green-dark">{t(`${type}`)}</span>
          <span>{name}</span>
        </div>
        {isTutor && (
          <AddCommentButton
            displayCommentTextarea={displayCommentTextarea}
            setDisplayCommentTextarea={setDisplayCommentTextarea}
          />
        )}
      </div>
      {displayCommentTextarea && (
        <AddComment
          currentComment={currentComment}
          sessionId={id}
          setDisplayCommentTextarea={setDisplayCommentTextarea}
        />
      )}
    </Fragment>
  )
}
